import { TOGGLE_ADVANCED_A11Y_ENABLED } from './a11yActionTypes';

export const toggleAdvancedA11yEnabled = () => ({
  type: TOGGLE_ADVANCED_A11Y_ENABLED,
});
